import { ReactComponent as FireExtinguishing } from "../../statics/icons/alarm.svg";
import { ReactComponent as AntiBulglaryDoor } from "../../statics/icons/anti_burglary.svg";
import { ReactComponent as Inflammable } from "../../statics/icons/inflammable.svg";
import { ReactComponent as Window } from "../../statics/icons/window.svg";
import { ReactComponent as CareTaker } from "../../statics/icons/oc_in_private_life.svg";
import React from "react";


export interface AdditionalProtectionsModel {
    antiburglarDoors: boolean;
    caretaker: boolean;
    antiburglarInstallation: boolean;
    firefightingInstallation: boolean;
    fireExtinguishing: boolean;
    securityWindows: boolean;
}

export enum AdditionalProtectionId {
    antiburglarDoors = "antiburglarDoors ",
    caretaker = "caretaker",
    antiburglarInstallation = "antiburglarInstallation ",
    firefightingInstallation = "firefightingInstallation",
    fireExtinguishing = "fireExtinguishing",
    securityWindows = "securityWindows"
}

export const DefaultAdditionalProtections: AdditionalProtectionsModel = {
    antiburglarDoors: false,
    caretaker: false,
    antiburglarInstallation: false,
    firefightingInstallation: false,
    fireExtinguishing: false,
    securityWindows: false
};

export interface Protection {
    additionalProtection: AdditionalProtectionId;
    displayName: string;
    icon: React.ReactNode;
}

export const SecurityTypes: Protection[] = [
    {
        additionalProtection: AdditionalProtectionId.antiburglarDoors,
        displayName: "Drzwi antywłamaniowe",
        icon: <AntiBulglaryDoor className="icon-svg-color" />
    },
    {
        additionalProtection: AdditionalProtectionId.caretaker,
        displayName: " Stały dozór ochrony",
        icon: <CareTaker className="icon-svg-color" />
    },
    {
        additionalProtection: AdditionalProtectionId.antiburglarInstallation,
        displayName: "Alarm z powiadomieniem",
        icon: <FireExtinguishing className="icon-svg-color" />
    },
    {
        additionalProtection: AdditionalProtectionId.firefightingInstallation,
        displayName: "Przeciwpożarowa instalacja sygnalizacyjna",
        icon: <Inflammable className="icon-svg-color" />
    },
    {
        additionalProtection: AdditionalProtectionId.fireExtinguishing,
        displayName: "Przeciwpożarowy system gaszący",
        icon: <Inflammable className="icon-svg-color" />
    },
    {
        additionalProtection: AdditionalProtectionId.securityWindows,
        displayName: "Zabezpieczenie okien",
        icon: <Window className="icon-svg-color" />
    }
];
